export default {"src":"/_next/static/media/circle-valid.50dbbec5.svg","height":1024,"width":1024,"blurWidth":0,"blurHeight":0};